// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@awc/App/Store/Reducers";
import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { chain, SetShipTo } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetInitialValues";
import cloneDeep from "lodash/cloneDeep";

export const XngSetShipTo: typeof SetShipTo = props => {
    // XNG-Change: if user was editing the shipto address, we need to keep the current editing values
    const state = props.getState() as CustomAppState;

    if (!props.cart.shipToId || (state.pages.checkoutShipping?.shippingAddressFormState?.address)) {
        return;
    }

    const shipTo = getShipToState(state, props.cart.shipToId).value;
    if (!shipTo) {
        throw new Error("The ship to for the current cart was not loaded.");
    }

    props.shipTo = cloneDeep(shipTo);
};

replaceInChain(chain, SetShipTo, XngSetShipTo);
